// extracted by mini-css-extract-plugin
export default {"form":"VerifierOTP_form__SWcZK","input":"VerifierOTP_input__fanxH","button":"VerifierOTP_button__ixH2I","loader":"VerifierOTP_loader__uN83N"};